export const useTruncate = (val_body, length, delimiter = '...') => {
  const truncate = _truncate(val_body, {
    length: length,
    separator: ' ',
    omission: delimiter
  })
  return truncate
}